module.exports = __webpack_public_path__ + "img/portrait-small.197b4b1e.png";